<main tuiNavigationMain [style.border]="'0px!important'">
  <!-- Vendor View Mode Header -->


  <div class="main-content">
    <div [style.grid-column]="'3 / span 8'">
      <div [style.margin-bottom.rem]="1.25" [style.margin-top.rem]="1.25" class="header-section">
        <!-- Header section -->
        <form tuiGroup class="group" [collapsed]="true" [formGroup]="headerGroupForm" style="width: auto;">
          <tui-segmented [size]="'s'">
            <button type="button" tuiOption="profile" (click)="headerGroupForm.get('testValue')?.setValue('profile')">
              Profile
            </button>

            <button type="button" tuiOption="notification"
              (click)="headerGroupForm.get('testValue')?.setValue('notification')">
              Notification
            </button>
          </tui-segmented>
        </form>
      </div>
    </div>

    <div [style.grid-column]="'3 / span 8'">
      <div *ngIf="headerGroupForm.get('testValue')?.value === 'profile'">
        <div [style.grid-column]="'3 / span 8'" [style.margin-top.rem]="1.25" [style.padding-bottom.rem]="2.25">
          <!-- User info section -->
          <div class="user-info">
            <div class="user-info-item">
              <div class="user-icon" [style.margin-bottom.rem]="1">
                <tui-avatar size="xxl"
                  [style.background-color]="getAvatarSrc() ? 'transparent' : 'var(--tui-background-neutral-1)'"
                  [style.color]="'var(--tui-text-primary)'"
                  (click)="getUserAvatarSrc() ? showLogoPreview() : triggerUserAvatarFileInput()" class="user-avatar"
                  style="cursor:pointer; position: relative; overflow: visible;">
                  <img *ngIf="getAvatarSrc()" [src]="getAvatarSrc()" alt="Avatar" style="width: 100%; height: 100%; object-fit: cover; border-radius: inherit;" />
                  <ng-container *ngIf="!getUserAvatarSrc()">
                    {{ getUserInitials() }}
                  </ng-container>

                  <!-- Scanner + Fill Upload Overlay -->
                  <div class="upload-progress-overlay" *ngIf="isLogoUploading" (click)="$event.stopPropagation()">
                    <!-- Vertical Fill Progress -->
                    <div class="fill-progress" [style.height.%]="logoUploadProgress" [class.success]="showSuccessCheck">
                    </div>

                    <!-- Glowing Scanner Line -->
                    <div class="scanner-line" *ngIf="!showSuccessCheck"></div>

                    <!-- Percentage Count -->
                    <div class="progress-info" *ngIf="!showSuccessCheck">
                      <span class="percentage">{{ logoUploadProgress }}%</span>
                      <span class="label">Uploading...</span>
                    </div>

                    <!-- Success Checkmark -->
                    <div class="success-checkmark" *ngIf="showSuccessCheck">
                      <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                      </svg>
                    </div>
                  </div>
                </tui-avatar>
                <div class="user-icon-camera" style="cursor:pointer;" *ngIf="!getUserAvatarSrc()">
                  <ng-container *ngIf="!isLogoUploading">
                    <tui-avatar src="@tui.camera" size="s"
                      [style.background-color]="'var(--tui-background-neutral-2-pressed)'"
                      [style.color]="'var(--tui-text-primary)'" (click)="triggerUserAvatarFileInput()"></tui-avatar>
                  </ng-container>
                </div>


                <input #userAvatarFileInput type="file" accept="image/png, image/jpeg, image/svg+xml"
                  style="display:none" (change)="onUserAvatarFileSelected($event)" />
              </div>
              <tui-error *ngIf="avatarSizeError" [error]="avatarSizeError" class="tui-space_bottom-2"></tui-error>
              <header tuiHeader="h4">
                <hgroup tuiTitle>
                  <h4>Welcome, {{ currentUser?.name || ((currentUser?.firstName || '') + ' ' + (currentUser?.lastName ||
                    '')).trim() || 'User' }}</h4>
                  <p tuiSubtitle>Manage your info, team, privacy, and security to make Sistem Apps work better for you
                    and
                    everyone associated.</p>
                </hgroup>
              </header>
              <div class="user-activity">
                <p class="tui-text_body-s">Account created on • {{ getFormattedCreatedAt() }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Basic info card -->
        <div [style.grid-column]="'3 / span 8'" tuiForm="m" [style.margin-top.rem]="2.25"
          [style.overflow]="'clip!important'">
          <div class="feature-box">
            <div class="feature-box-item">
              <div tuiAppearance="outline" tuiCardLarge class="profile-scroll-card" [style.borderRadius.rem]="0.75"
                [style.padding-bottom.rem]="'1'">
                <h6 [style.font]="'var(--tui-font-heading-6)'" [style.margin-bottom.rem]="'-0.25'">
                  <span [style.margin-bottom.rem]="1" [style.color]="'var(--tui-text-primary)'">Your Profile</span>
                </h6>
                <tui-chip appearance="accent" [style.text-transform]="'capitalize'" *ngIf="tag">{{tag}}</tui-chip>
                <p [style.color]="'var(--tui-text-secondary)'" [style.font-size]="'var(--tui-font-text-ui-m)'"
                  [style.margin-top.rem]="'-1.25'">Some info may be visible to other people using Sistem
                  services.
                  <button tuiLink type="button" [style.text-decoration-line]="'underline'"
                    [textContent]="'Learn More'"></button>
                </p>
                <div class="more-info">
                  <div class="more-info-item" *ngFor="let item of data; let i = index">
                    <div class="more-info-item-label">
                      <span class="more-info-item-label-text" [style.color]="'var(--tui-text-secondary)'"
                        [style.font]="'var(--tui-font-text-ui-m)'" [style.font-size]="'15px'">
                        {{item.key}}
                      </span>
                    </div>
                    <div class="more-info-item-value">
                      <span class="more-info-item-value-text" [style.color]="'var(--tui-text-primary)'"
                        [style.font]="'var(--tui-font-text-ui-m)'" [style.font-size]="'15px'">
                        <!-- Read-only fields (Email, Company) -->
                        <ng-container *ngIf="item.isReadOnly">
                          <tui-textfield size="s" tuiTextfieldSize="s">
                            <input [placeholder]="'Enter ' + item.key.toLowerCase()" tuiTextfield [readOnly]="true"
                              [(ngModel)]="item.value" [style.outline]="!isEditMode ? 'none' : 'revert-layer'"
                              [style.background]="!isEditMode ? 'transparent' : 'auto'"
                              [style.font-size]="'var(--tui-font-text-ui-m)'" />
                            <tui-icon *ngIf="item.key === 'Email'" appearance="flat"
                              tuiTooltip="Verified email. We can't change email because of security reason."
                              tuiHintDirection="right" [style.color]="'var(--tui-text-positive)'"
                              [style.font-size]="'15px'" icon="@tui.circle-check" [style.margin-right.px]="'5'" />
                          </tui-textfield>
                        </ng-container>
                        <!-- Editable fields -->
                        <ng-container *ngIf="!item.isReadOnly">
                          <tui-textfield size="s" tuiTextfieldSize="s">
                            <input #firstInput [placeholder]="'Enter ' + item.key.toLowerCase()" tuiTextfield
                              [readOnly]="!isEditMode" [(ngModel)]="item.value"
                              [style.outline]="!isEditMode ? 'none' : 'revert-layer'"
                              [style.background]="!isEditMode ? 'transparent' : 'auto'" [style.font-size]="'15px'" />
                          </tui-textfield>
                        </ng-container>
                      </span>
                    </div>
                  </div>
                </div>

                <footer class="footer-button">
                  <div style="display: flex; gap: 0.5rem;">
                    <button size="m" tuiButton type="button" [appearance]="isEditMode ? 'primary' : 'flat'"
                      (click)="toggleEditMode()">
                      {{ isEditMode ? 'Save Profile' : 'Edit Profile' }}
                    </button>
                    <button *ngIf="isEditMode" size="m" tuiButton type="button" appearance="outline"
                      (click)="cancelEditMode()" style="color: var(--tui-error-fill);">
                      Cancel
                    </button>
                  </div>
                </footer>
              </div>
            </div>

            <div class="feature-box-item">
              <div tuiAppearance="outline" tuiCardLarge class="profile-scroll-card" [style.borderRadius.rem]="0.75"
                [style.padding-bottom.rem]="'1'">
                <h6 [style.font]="'var(--tui-font-heading-6)'" [style.margin-bottom.rem]="''">
                  <span [style.margin-bottom.rem]="1" [style.color]="'var(--tui-text-primary)'">Password</span>
                </h6>
                <!-- <tui-chip appearance="accent">{{tag}}</tui-chip> -->
                <p [style.color]="'var(--tui-text-secondary)'" [style.font-size]="'var(--tui-font-text-ui-m)'"
                  [style.margin-top.rem]="''">A secure password helps protect your Sistem account. We advice you
                  to keep updating the password after every month.</p>

                <div class="info-table" [style.margin-top.rem]="-0.25">
                  <!-- Password table with individual field editing -->
                  <div class="more-info">
                    <div class="more-info-item" *ngFor="let item of dataPassword; let i = index">
                      <div class="more-info-item-label">
                        <span class="more-info-item-label-text" [style.color]="'var(--tui-text-secondary)'"
                          [style.font]="'var(--tui-font-text-ui-m)'" [style.font-size]="'15px'">
                          {{item.key}}
                        </span>
                      </div>
                      <div class="more-info-item-value">
                        <span class="more-info-item-value-text" [style.color]="'var(--tui-text-primary)'"
                          [style.font]="'var(--tui-font-text-ui-m)'" [style.font-size]="'15px'">
                          <ng-container>
                            <tui-textfield size="s" tuiTextfieldSize="s">
                              <input #firstInput placeholder="Enter Password" tuiTextfield
                                [readOnly]="!isPasswordEditMode" [(ngModel)]="item.value"
                                (ngModelChange)="onPasswordValueChange($event, i)"
                                [style.outline]="!isPasswordEditMode ? 'none' : 'revert-layer'"
                                [style.background]="!isPasswordEditMode ? 'transparent' : 'auto'"
                                [style.font-size]="'var(--tui-font-text-ui-m)'" />
                              <tui-icon tuiPassword *ngIf="isPasswordEditMode" />
                            </tui-textfield>
                            <!-- Error display for password fields -->
                            <div *ngIf="isPasswordEditMode && item.key === 'Password' && passwordError"
                              [style.color]="'var(--tui-text-negative)'" [style.font-size.px]="'13'"
                              [style.margin-top.px]="'4'">
                              {{ passwordError }}
                            </div>
                            <div *ngIf="isPasswordEditMode && item.key === 'Confirm' && repeatPasswordError"
                              [style.color]="'var(--tui-text-negative)'" [style.font-size.px]="'13'"
                              [style.margin-top.px]="'4'">
                              {{ repeatPasswordError }}
                            </div>
                          </ng-container>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="change-password-date tui-text_body-s" [style.font-size]="'var(--tui-font-text-ui-m)'"
                    *ngIf="!isPasswordEditMode">Last
                    changed {{ currentUser?.updatedAt | tuiFormatDate | async }}</div>
                </div>


                <footer class="footer-two-factor">
                  <div class="two-factor-section">
                    <label tuiCell [style.padding-top.rem]="'0'" [style.background-color]="'transparent'">
                      <div class="two-factor-section-item">
                        <div class="tui-text_body-m" [style.font-size]="'var(--tui-font-text-ui-m)'"
                          [style.font-weight]="'var(--medium)'">Two-Factor Authentication</div>
                        <div tuiSubtitle class="tui-text_body-s">Add an extra layer of security. We will send you an OTP
                          on
                          your email every time you login.</div>
                      </div>
                      <input tuiSwitch type="checkbox" [formControl]="twoFactorControl" size="m" />
                    </label>
                    <!-- <div class="tui-text_body-s" [style.font-size]="'var(--tui-font-text-ui-s)'" [style.color]="'var(--tui-text-secondary)'" [style.margin-top.px]="'8'">
                  {{ twoFactorControl.value ? 'OTP verification will be required to change password.' : 'Password can be changed directly without OTP verification.' }}
                </div> -->
                  </div>
                  <div class="footer-button">
                    <div style="display: flex; gap: 0.5rem;">
                      <button size="m" tuiButton type="button" [appearance]="isPasswordEditMode ? 'primary' : 'flat'"
                        (click)="onChangePasswordClick()">
                        {{ isPasswordEditMode ? 'Save Password' : (twoFactorControl.value ? 'Change Password' : 'Change
                        Password') }}
                      </button>
                      <button *ngIf="isPasswordEditMode" size="m" tuiButton type="button" appearance="outline"
                        (click)="cancelPasswordEditMode()" style="color: var(--tui-error-fill);">
                        Cancel
                      </button>
                    </div>
                  </div>
                </footer>
              </div>
            </div>
          </div>

          <!-- login info -->
          <div tuiAppearance="outline" tuiCardLarge class="profile-scroll-card" [style.borderRadius.rem]="0.75"
            [style.padding-bottom.rem]="'1'">
            <h6 [style.font]="'var(--tui-font-heading-6)'" [style.margin-bottom.rem]="'1'">
              <span [style.margin-bottom.rem]="1" [style.color]="'var(--tui-text-primary)'">Where you're logged
                in</span>
            </h6>
            <p [style.color]="'var(--tui-text-secondary)'" [style.font-size]="'var(--tui-font-text-ui-m)'"
              [style.margin-top.rem]="'-1.25'">You're signed in on these devices or have been in the last 28 days.
              There might be multiple activity sessions from the same device.
              <button tuiLink type="button" [style.text-decoration-line]="'underline'"
                [textContent]="'How locations and times are determined?'"></button>
            </p>

            <tui-loader [overlay]="true" [showLoader]="loadingSessions()">
              <div class="info-table login-info-table" [style.margin-top.rem]="'-0.25'">
                <table tuiTable class="table" [columns]="deviceColumns" size="s" [style.width]="'100%'">
                  <thead>
                    <tr tuiThGroup>
                      <th tuiTh [resizable]="true">DEVICE</th>
                      <th tuiTh>LOCATION</th>
                      <th tuiTh>LAST ACTIVITY</th>
                      <th tuiTh></th>
                    </tr>
                  </thead>
                  <tbody tuiTbody [data]="activeSessions()">
                    <tr *ngFor="let item of activeSessions()" tuiTr>
                      <td *tuiCell="'device'" tuiTd>
                        <div tuiCell="m">
                          <tui-avatar size="s" appearance="secondary" [src]="item.device.icon"
                            [style.color]="'var(--tui-text-secondary)'" [style.border-radius.rem]="0.725" />
                          <div tuiTitle>
                            <span class="ttui-text_body-m-2 bold" [style.text-transform]="'capitalize'">
                              {{ item.device.name }}
                              <tui-badge *ngIf="item.isCurrent" size="s" appearance="positive" tuiStatus
                                [style.margin-left.rem]="0.5">
                                Current
                              </tui-badge>
                            </span>
                            <div tuiSubtitle>
                              {{ item.device.browser }} • {{ item.device.ip }}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td *tuiCell="'location'" tuiTd>
                        <tui-icon icon="@tui.map-pin" [style.color]="'var(--tui-text-secondary)'" size="s"
                          [style.width.px]="'16'" /> {{ item.location }}
                      </td>
                      <td *tuiCell="'last-activity'" tuiTd>
                        {{ item.lastActivity ? (item.lastActivity | date:'d MMM, h:mm a') : 'Just now' }}
                      </td>
                      <td *tuiCell="'action'" tuiTd [style.text-align]="'right'">
                        <button appearance="flat" size="s" tuiIconButton type="button" class="icon-red"
                          (click)="logoutDevice(item)">
                          <tui-icon appearance="flat" tuiTooltip="Logout" tuiHintDirection="right" class="icon-red"
                            icon="@tui.log-out" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </tui-loader>

            <footer class="footer-button">
              <button size="m" tuiButton type="button" appearance="flat" [style.color]="'#DD4C1E'"
                (click)="logoutAllSessions()">
                Log out of all sessions
              </button>
            </footer>
          </div>

          <div tuiAppearance="outline" tuiCardLarge class="profile-scroll-card" [style.borderRadius.rem]="0.75"
            [style.padding.rem]="'1.25'" [style.margin-bottom.rem]="'2.25'">
            <div tuiCell="s">
              <tui-avatar size="s" appearance="flat" src="@tui.shield-alert" [style.border-radius.rem]="0.725"
                [style.color]="'var(--tui-text-secondary)'" [style.background-color]="'transparent'" />
              <div tuiTitle>
                <div class="tui-text_body-m" [style.color]="'var(--tui-text-secondary)'">Where you Only you can see your
                  settings. Sistem App is committed to protecting your privacy
                  and security.</div>
              </div>
            </div>
          </div>
        </div>
      </div>




      <div *ngIf="headerGroupForm.get('testValue')?.value === 'notification'">
        <div tuiAppearance="outline-grayscale" tuiCardLarge tuiForm="m" [style.margin-top.rem]="1.25"
          [style.widht.%]="100" [style.borderRadius.rem]="0.75" class="no-passes-message"
          style="text-align: center; padding: 2rem; color: var(--tui-text-secondary);">
          <tui-block-status size="m">
            <img alt="survived" src="assets/images/icons/going-up.svg" tuiSlot="top" />
            <h4 [style.color]="'var(--tui-text-primary)'">Comming Soon</h4>
            <span [style.color]="'var(--tui-text-secondary)'">We're working on it! This feature will be available
              soon.</span>
          </tui-block-status>
        </div>

      </div>
    </div>

  </div>




  <!-- otp modal -->
  <div class="otp-modal-container" *ngIf="showOtpModal">
    <div tuiAppearance="floating" tuiCardLarge class="otp-modal" [formGroup]="otpForm"
      [style.background-color]="'var(--tui-background-base)'">
      <h2 tuiTitle>
        We'll need additional information
        <span tuiSubtitle [style.font-size]="'var(--tui-font-text-ui-m)'">For security reasons, we need to verify it's
          you before we complete this action.</span>
      </h2>
      <div class="otp-modal-content" [style.margin-top.rem]="'-1'">
        <p>We have sent a verification code to:</p>
        <p class="otp-modal-content-email" [style.font-weight]="'var(--semi-bold)'">{{ currentUser?.email }}</p>
      </div>
      <div class="otp-modal-input">
        <tui-textfield>
          <input maxlength="6" tuiInputPin formControlName="otpValue" tuiTextfieldSize="m"
            (keydown.enter)="verifyOtp()" />
        </tui-textfield>
        <div class="modal-status-message"
          [style.color]="isSuccessMessage ? 'var(--tui-status-positive)' : 'var(--tui-text-negative)'"
          [style.font-size.px]="13" [style.margin-top.px]="4" *ngIf="modalErrorMessage">
          {{ modalErrorMessage }}
        </div>
        <button size="s" tuiButton type="button" appearance="flat" [style.margin-top.px]="'4'"
          [style.background]="'none'" class="resend-code-button" (click)="resendOtp()" [disabled]="!canResendOtp">
          {{ canResendOtp ? 'Resend code again' : 'Resend code again (' + resendTimer + 's)' }}
        </button>
      </div>
      <tui-notification size="m" [style.margin-top.px]="'-4'">
        <p>Make sure to check the spam, just incase you cant find the code. <button tuiLink type="button"
            [style.text-decoration-line]="'underline'" [textContent]="'Read our support page'"
            [style.color]="'var(--tui-text-action)'"></button> for changing password.</p>
      </tui-notification>

      <div class="otp-modal-footer">
        <button tuiButton type="button" appearance="flat" size="m" (click)="closeOtpModal()">Cancel</button>
        <button tuiButton type="button" appearance="primary" size="m" (click)="verifyOtp()">Verify</button>
      </div>
    </div>
  </div>
</main>


<!-- Email Update Dialog Template -->
<ng-template #emailUpdateDialog let-observer>
  <div style="text-align: left; display: flex; flex-direction: column; gap: 1rem; width: 100%;">
    <tui-notification status="warning" size="m">
      To change your password or configure Two-Factor Authentication, please first update your email.
    </tui-notification>


    <app-input-heading heading="Enter Email"></app-input-heading>


    <tui-textfield style="width: 100%;">
      <input type="email" tuiTextfield [placeholder]="'example@domain.com'" [(ngModel)]="newEmailValue"
        (keydown.enter)="onEmailUpdateSubmit(observer)" />
    </tui-textfield>

    <div class="modal-status-message" [style.color]="'var(--tui-text-negative)'" [style.font-size.px]="13"
      [style.margin-top.px]="-8" *ngIf="emailUpdateErrorMessage">
      {{ emailUpdateErrorMessage }}
    </div>

    <div style="display: flex; justify-content: flex-end; gap: 0.5rem; margin-top: 0.5rem;">
      <button tuiButton type="button" appearance="flat" size="m" (click)="observer.complete()">Cancel</button>
      <button tuiButton type="button" appearance="primary" size="m" (click)="onEmailUpdateSubmit(observer)"
        [disabled]="isEmailUpdating">Update Email</button>
    </div>
  </div>
</ng-template>

<!-- Logo Preview Template -->
<ng-template #logoPreview let-preview>
  <tui-preview [rotatable]="false">
    <tui-preview-title>User Profile Logo</tui-preview-title>

    <button iconStart="@tui.download" tuiIconButton tuiPreviewAction type="button" (click)="downloadLogo()">
      Download
    </button>

    <button iconStart="@tui.refresh-cw" tuiIconButton tuiPreviewAction type="button"
      (click)="replaceUserAvatar(preview)">
      Replace
    </button>


    <button iconStart="@tui.trash" tuiIconButton tuiPreviewAction type="button" (click)="removeProfilePhoto(preview)">
      Remove
    </button>

    <button iconStart="@tui.x" tuiIconButton tuiPreviewAction type="button" (click)="preview.complete()">
      Close
    </button>

    <img [src]="getAvatarSrc()" alt="logo preview"
      style="width: 100%; height: 100%; min-width: 280px; min-height: 280px; max-width: 80vw; max-height: 80vh; object-fit: contain;" />
  </tui-preview>
</ng-template>